import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Organization, UserInfo } from "../../services/UserService";
import { RootState } from "../Store";

interface UserState {
  organizations: Organization[];
  userInfo: UserInfo;
  currentOrganization?: Organization;
}

export const initialState: UserState = {
  organizations: [],
  userInfo: { name: "", id: "" },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setOrganizations: (state, action: PayloadAction<Organization[]>) => {
      if (action.payload.length === 0) return;
      state.organizations = action.payload;
      state.currentOrganization = state.organizations[0];
    },
    setUserInfo: (state, action: PayloadAction<UserInfo>) => {
      state.userInfo = action.payload;
    },
    setCurrentOrganization: (state, action: PayloadAction<Organization>) => {
      state.currentOrganization = action.payload;
    },
  },
});

// reducers
export const { setOrganizations, setUserInfo, setCurrentOrganization } =
  userSlice.actions;

// selectors
export const selectOrganizations = (state: RootState) =>
  state.user.organizations;
export const selectUsername = (state: RootState) => state.user.userInfo.name;
export const selectUserId = (state: RootState) => state.user.userInfo.id;
export const selectCurrentOrganization = (state: RootState) =>
  state.user.currentOrganization;
// export const selectIsGreygin = (state: RootState) =>
//   state.user.currentOrganization?.id ===
//     "ba31195f-b096-475d-81c1-86e9c4cfd184" ||
//   state.user.currentOrganization?.id === "d1a04fe7-7db4-4594-aa1c-a0fced0e0e0f";

export const selectCurrentOrganizationIsWhitelisted = (state: RootState) =>
  process.env.REACT_APP_PLAYIT_WHITELISTED_ORGANIZATIONS?.split(",").includes(
    state.user.currentOrganization?.id || ""
  );

/**
 * Gates settings that only PlayIt staff should see, currently the auto connect
 * to Unity toggle.
 *
 * There is no role model in the app yet. @playit/shared-authentication defines
 * Roles.SuperUser (30) and the authenticate response carries a role, but the
 * hook the app logs in with never surfaces it, and the app always requests
 * Roles.Creator anyway. Until a real role reaches the store, "super user"
 * means "member of an internal organisation", which is what the whitelist
 * already expresses. Swap the body when that changes, not the call sites:
 * exactly one component reads this.
 */
export const selectIsSuperUser = (state: RootState) =>
  Boolean(selectCurrentOrganizationIsWhitelisted(state));

export const selectAllowWrongAnswersWhitelisted = (state: RootState) =>
  process.env.REACT_APP_ALLOW_WRONG_ANSWERS_WHITELISTED_ORGANIZATIONS?.split(
    ","
  ).includes(state.user.currentOrganization?.id || "");

export default userSlice.reducer;
